// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2zMk0","mobileMenuOpen":"styles_mobileMenuOpen__1Ne3k","content":"styles_content__1NrcQ"};